import React from 'react';
import { Image } from 'react-bootstrap';
import spinner from '../../../images/loader.gif';

const Spinner = () => {
    return (
        <section className="w-100 d-flex justify-content-center align-items-center">
            <Image src='https://i.gifer.com/47tt.gif' />
        </section>
    );
};

export default Spinner;